import { useSelector } from 'react-redux';
import type { RootState } from '../../Redux/Store';

const NavMenuMobile = () => {
  const dark = useSelector((state: RootState) => state.themeSlice.dark);
  const isTablet = useSelector((state: RootState) => state.tabletSlice.isTablet);
  const size = isTablet ? 30 : 20;
  const height = isTablet ? 30 : 21;

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.5002 4.505H2.50019C2.28425 4.52812 2.08449 4.63027 1.93933 4.7918C1.79417 4.95333 1.71387 5.16283 1.71387 5.38C1.71387 5.59717 1.79417 5.80667 1.93933 5.9682C2.08449 6.12973 2.28425 6.23188 2.50019 6.255H17.5002C17.623 6.26814 17.7471 6.25531 17.8646 6.21732C17.9821 6.17934 18.0902 6.11706 18.1821 6.03454C18.2739 5.95201 18.3473 5.85108 18.3976 5.73832C18.4479 5.62555 18.4739 5.50347 18.4739 5.38C18.4739 5.25653 18.4479 5.13445 18.3976 5.02168C18.3473 4.90892 18.2739 4.80799 18.1821 4.72546C18.0902 4.64294 17.9821 4.58066 17.8646 4.54268C17.7471 4.50469 17.623 4.49186 17.5002 4.505Z"
        fill={dark ? '#fff' : 'black'}
      />
      <path
        d="M17.5002 9.505H2.50019C2.28425 9.52812 2.08449 9.63027 1.93933 9.7918C1.79417 9.95333 1.71387 10.1628 1.71387 10.38C1.71387 10.5972 1.79417 10.8067 1.93933 10.9682C2.08449 11.1297 2.28425 11.2319 2.50019 11.255H17.5002C17.623 11.2681 17.7471 11.2553 17.8646 11.2173C17.9821 11.1793 18.0902 11.1171 18.1821 11.0345C18.2739 10.952 18.3473 10.8511 18.3976 10.7383C18.4479 10.6255 18.4739 10.5035 18.4739 10.38C18.4739 10.2565 18.4479 10.1345 18.3976 10.0217C18.3473 9.90892 18.2739 9.80799 18.1821 9.72546C18.0902 9.64294 17.9821 9.58066 17.8646 9.54268C17.7471 9.50469 17.623 9.49186 17.5002 9.505Z"
        fill={dark ? '#fff' : 'black'}
      />
      <path
        d="M17.5002 14.505H2.50019C2.28425 14.5281 2.08449 14.6303 1.93933 14.7918C1.79417 14.9533 1.71387 15.1628 1.71387 15.38C1.71387 15.5972 1.79417 15.8067 1.93933 15.9682C2.08449 16.1297 2.28425 16.2319 2.50019 16.255H17.5002C17.623 16.2681 17.7471 16.2553 17.8646 16.2173C17.9821 16.1793 18.0902 16.1171 18.1821 16.0345C18.2739 15.952 18.3473 15.8511 18.3976 15.7383C18.4479 15.6255 18.4739 15.5035 18.4739 15.38C18.4739 15.2565 18.4479 15.1345 18.3976 15.0217C18.3473 14.9089 18.2739 14.808 18.1821 14.7255C18.0902 14.6429 17.9821 14.5807 17.8646 14.5427C17.7471 14.5047 17.623 14.4919 17.5002 14.505Z"
        fill={dark ? '#fff' : 'black'}
      />
    </svg>
  );
};

export default NavMenuMobile;
